module.exports = new __parcel__URL__("decision-dark.70f9a9e4.png").toString();